// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CloudinaryImage_placeholder__kWdxK"};